import Customer from '../../../../../global/js/magento-api-library/types/Customer'

export interface State {
  customer: Customer | null
}

export const state: State = {
  customer: null,
}
